import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ajtucnxx1w: FaireBrandEntity = {
  token: "b_ajtucnxx1w",
  type: "brand",
  name: "Three Potato Four",
  avatarUrl:
    "https://cdn.faire.com/fastly/caaf39ea54c8d4059227dda4ecbb6460d3b0b34104216969eabad181017282d8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0ca69ed2b2b610f9fec91378cb60e23f44ed31c5f172bd208167e4f0411c9a6a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/caaf39ea54c8d4059227dda4ecbb6460d3b0b34104216969eabad181017282d8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0ca69ed2b2b610f9fec91378cb60e23f44ed31c5f172bd208167e4f0411c9a6a.jpeg",
  location: "Media, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 467,
  isTopShop: true,
  isInsider: true,
  description:
    "Hello! We're Three Potato Four and we've been bringing back your favorite vintage-inspired gifts and accessories since 2007! From felt pennants, hotel key tags, coin pouches, card packs, and more, our super fun ever-expanding product line blends beloved nostalgic vintage objects with contemporary trend-driven designs.\n\nInterested in custom products? Absolutely! Our full-service boutique design and sourcing studio collaborates with small to large retail, fashion, and lifestyle brands on design development of exclusive product collections. Get in touch!\n\nPlease be aware that our products are not authorized for resale on third-party platforms, including but not limited to Amazon, Etsy, and eBay. Unauthorized sales on these platforms may result in the termination of your wholesale account",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:02.412Z",
    importedBy: "entity-db-cli",
  },
};
